module.exports = __webpack_public_path__ + "static/media/vip_popular.c6652b0b.svg";